var React = require('react');

function Oval (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30 0.499999C46.2924 0.499998 59.5 13.7076 59.5 30C59.5 46.2924 46.2924 59.5 30 59.5C13.7076 59.5 0.499999 46.2924 0.499999 30C0.499998 13.7076 13.7076 0.499999 30 0.499999Z","fill":"url(#paint0_linear_5431_35582)","stroke":"white","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_5431_35582","x1":"-1.38877e-06","y1":"30","x2":"60","y2":"30","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"white","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"0.0001","stopColor":"#BA0671","stopOpacity":"0.06","key":1}),React.createElement("stop",{"offset":"1","stopColor":"#BA0671","stopOpacity":"0.2","key":2})]))]);
}

Oval.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Oval;

Oval.default = Oval;
